import React, { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { FieldLabel, Select, Option } from 't3-widgets'

import { DeviceTypeHandler } from '../../../../../../../../common/components/device-type-handler/device-type-handler'
import { MobileNativeOption } from '../../../../../../../../common/components/mobile-native-select/mobile-native-option'
import { MobileNativeSelect } from '../../../../../../../../common/components/mobile-native-select/mobile-native-select'

import styles from '../../../pages.module.css'

const ContractsField = ({ intl, onChange, tariffs, value }) => {
    const contractsSet = useMemo(() => {
        return new Set()
    }, [])

    tariffs.forEach(tariff => {
        if (!contractsSet.has(tariff.number)) {
            contractsSet.add(tariff.number)
        }
    })

    const contracts = useMemo(() => {
        return [...contractsSet]
    }, [contractsSet])

    useEffect(() => {
        if (contracts && contracts.length > 0) {
            const contract = value || contracts[0]

            onChange({
                target: {
                    value: contract
                }
            })
        }
    }, [tariffs, value, onChange, contracts])

    const desktopDeviceComponent = (
        <Select
            id="contracts-field-select"
            placeholder={intl.translate('ap_confirmationpage_contractnumber')}
            className={styles['select-field']}
            key="wf-sub-model"
            {...{ onChange, value }}
        >
            {contracts.map((contractNumber, index) => {
                return (
                    <Option id={`contracts-field-select-option-${index}`} key={index} value={contractNumber}>
                        {contractNumber}
                    </Option>
                )
            })}
        </Select>
    )

    const mobileDeviceComponent = (
        <MobileNativeSelect
            id="contracts-field-select-mobile"
            placeholder={intl.translate('ap_confirmationpage_contractnumber')}
            className={styles['select-field']}
            key="wf-sub-model"
            {...{ onChange, value }}
        >
            {contracts.map((contractNumber, index) => {
                return (
                    <MobileNativeOption
                        id={`contracts-field-select-option-mobile-${index}`}
                        key={index}
                        value={contractNumber}
                    >
                        {contractNumber}
                    </MobileNativeOption>
                )
            })}
        </MobileNativeSelect>
    )

    return (
        <FieldLabel id="contracts-field-select-label" label={intl.translate('ap_confirmationpage_contractnumber')}>
            <DeviceTypeHandler {...{ desktopDeviceComponent, mobileDeviceComponent }} />
        </FieldLabel>
    )
}

ContractsField.propTypes = {
    intl: PropTypes.objectOf(PropTypes.func),
    onChange: PropTypes.func,
    tariffs: PropTypes.array,
    value: PropTypes.string
}

export { ContractsField }
